'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextHeight = getTextHeight;
exports.getTextWidth = getTextWidth;
var MEASURABLE_PROPERTIES = ['-webkit-font-smoothing', 'border', 'border-bottom-left-radius', 'border-bottom-right-radius', 'border-bottom-style', 'border-bottom-width', 'border-collapse', 'border-image-outset', 'border-image-repeat', 'border-image-slice', 'border-image-width', 'border-left-color', 'border-left-style', 'border-left-width', 'border-right-color', 'border-right-style', 'border-right-width', 'border-top-left-radius', 'border-top-right-radius', 'border-top-style', 'border-top-width', 'box-sizing', 'font-family', 'font-size', 'font-style', 'font-variant', 'font-weight', 'line-height', 'margin', 'padding', 'padding-bottom', 'padding-left', 'padding-right', 'padding-top', 'white-space', 'width', 'word-break', 'word-spacing', 'word-wrap'];

var getMeasureNode = function getMeasureNode(inputNode, elementType) {
  var inputNodeStyles = window.getComputedStyle(inputNode, null);
  var measureNode = document.createElement(elementType);
  MEASURABLE_PROPERTIES.forEach(function (property) {
    measureNode.style[property] = inputNodeStyles[property];
  });
  measureNode.style.position = 'relative';
  measureNode.appendChild(document.createTextNode((inputNode.value || inputNode.placeholder || '') + ' '));
  return measureNode;
};

var computeInputTextBounds = function computeInputTextBounds(inputNode, elementType) {
  var _document = document,
      body = _document.body;

  var measureNode = getMeasureNode(inputNode, elementType);
  body.appendChild(measureNode);
  var bounds = measureNode.getBoundingClientRect();
  body.removeChild(measureNode);
  return bounds;
};

// Get the height of the text in an <input> or <textarea>
function getTextHeight(inputNode) {
  return computeInputTextBounds(inputNode, 'pre').height;
}

// Get the width of the text in an <input> or <textarea>
function getTextWidth(inputNode) {
  return computeInputTextBounds(inputNode, 'span').width;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/utils/MeasureText.js
// module id = 314
// module chunks = 0